import { render } from "./expertExplain.vue?vue&type=template&id=63e5c94d"
import script from "./expertExplain.vue?vue&type=script&lang=js"
export * from "./expertExplain.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__